import { Provider } from '@angular/core';
import { NotificacionSignalRService } from '@core/services/notificacion-signalr.service';
import { AuthService } from '@core/services/auth.service';
import { HostConfigService } from '@core/services/host-config.service';
import { TokenService } from '@core/services/token/token.service';

export const PROVIDERS_LAYOUT: Provider[] = [NotificacionSignalRService, AuthService, HostConfigService, TokenService];
